export default __webpack_public_path__ + "static/media/icon_info_dialog.9bef2bdc.svg";